import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// EQUIPR products (e.g. Core) deep-link here by a module's sourceArticleId.
// We resolve it to the exact module, then route the learner there — signing
// them in first (with a return URL) if they don't have a session yet.
export default function ArticleRedirect() {
  const { articleId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (user === null) return; // wait until auth is known
    let active = true;
    api.get(`/resolve/article/${articleId}`)
      .then((res) => {
        if (!active) return;
        const path = res.data.path;
        if (user && typeof user === "object") navigate(path, { replace: true });
        else navigate(`/login?next=${encodeURIComponent(path)}`, { replace: true });
      })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [articleId, user, navigate]);

  if (error) {
    return (
      <div className="auth on-dark">
        <div className="auth__card" data-testid="article-notfound">
          <div className="auth__brand">
            <span className="nav__logo">EQUIPR</span>
            <span style={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-body-lg)" }}>Academy</span>
          </div>
          <h1 style={{ fontSize: "var(--fs-card-title)", fontWeight: "var(--fw-extrabold)", margin: "0 0 10px" }}>Topic not found</h1>
          <p className="auth__hint">We couldn't match that help topic to a module. It may have moved or been renamed.</p>
          <button className="btn btn--dark" style={{ marginTop: "16px" }} onClick={() => navigate("/")} data-testid="article-home">Go to the Academy</button>
        </div>
      </div>
    );
  }

  return <div className="loading" data-testid="article-resolving">Opening your module…</div>;
}
